export const FEEDBACK_BAR_LABELS = {
  SLEEP: [
    ["体動が少ない", "睡眠"],
    ["体動が多い", "睡眠"],
    ["覚醒", ""],
  ],
  HEART_BEAT: [
    ["最大レベル", "時間"],
    ["有酸素レベル", "時間"],
    ["歩行レベル", "時間"],
  ],
  TALK: ["朝(6-12時)", "昼(12-18時)", "夜(18-22時)"],
  KCAL: [["消費カロリー", "消費カロリー"]],
  SKIN_TEMPS: [
    ["日中最高温度", ""],
    ["日中最低温度", ""],
    ["日中平均温度", ""],
    ["睡眠時最高温度", ""],
    ["睡眠時最低温度", ""],
    ["睡眠時平均温度", ""],
  ],
};
